import Vue from 'vue';
import store from './../../store';
import { encodePathSegment } from '@/utils/url';

export default (customer) => {
  Vue.$http
    .delete(`Customers/${encodePathSegment(customer.id)}`)
    .then(() => {
      store.dispatch('customer/getCustomer');
    })
    .catch((error) => {
      console.log(error);
    });
};



// WEBPACK FOOTER //
// ./src/services/customer/del.js